/**
 * AppShell — racine du shell authentifié. Sélectionne le shell approprié
 * selon le breakpoint courant.
 *
 * @remarks
 * Le `manifest` reste **identique** quel que soit le breakpoint — c'est le
 * shell qui décide quoi rendre où. Cf. doc 02 §7.
 */

import { useBreakpoint } from '@/shared/hooks/use-breakpoint';
import { DesktopShell } from './DesktopShell';
import { TabletShell } from './TabletShell';
import { MobileShell } from './MobileShell';

export function AppShell() {
  const bp = useBreakpoint();

  if (bp === 'desktop') return <DesktopShell />;
  if (bp === 'tablet') return <TabletShell />;
  return <MobileShell />;
}
